module.exports = __webpack_public_path__ + "static/media/0327_IMG_L_ESPACE_DEGUSTATION_SANS.47e1acd7.png";